// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import mainCards from './js/widgets/mainCards.js';
import * as seoSignup from './js/widgets/seo-signup/index.js';
import sponsorsOfTheDay from './js/widgets/sponsorsOfTheDay.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    mainCards();
    seoSignup.customSeoBlock();
    seoSignup.customSignup();
    sponsorsOfTheDay();
    scrollerSponsors();
  }
});
